import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent } from '@/components/ui/card'

export function OrdersSkeleton() {
  return (
    <div className="space-y-3">
      {[1, 2, 3, 4].map((i) => (
        <Card key={i} className="border-s-4 border-s-muted-foreground/20">
          <CardContent className="p-4">
            {/* Row 1: id + time | total */}
            <div className="flex items-center justify-between mb-2.5">
              <div className="flex items-center gap-3">
                <Skeleton className="h-6 w-16" />
                <Skeleton className="h-4 w-20" />
              </div>
              <Skeleton className="h-6 w-16" />
            </div>

            {/* Row 2: items | payment chip */}
            <div className="flex items-center justify-between gap-3 mb-3">
              <Skeleton className="h-4 w-44" />
              <Skeleton className="h-5 w-12" />
            </div>

            {/* Row 3: status + type | phone */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <Skeleton className="h-6 w-24 rounded-full" />
                <Skeleton className="h-5 w-16 rounded-md" />
              </div>
              <Skeleton className="h-4 w-20" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

export function OrderDetailSkeleton() {
  return (
    <div className="h-full flex flex-col p-4">
      {/* Header */}
      <div className="space-y-3 mb-6">
        <div className="flex items-center gap-3">
          <Skeleton className="h-7 w-28" />
          <Skeleton className="h-6 w-20" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-5 w-24" />
          <Skeleton className="h-5 w-36" />
        </div>
      </div>

      {/* Customer */}
      <div className="space-y-3 mb-6">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-10 w-full" />
      </div>

      {/* Items */}
      <div className="space-y-3 mb-6">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>

      {/* Pricing */}
      <div className="space-y-2 mt-auto">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-6 w-full" />
      </div>
    </div>
  )
}
